import firstWordCapitalized from 'common/util/firstWordCapitalized';
import typeCheck from 'common/util/typeCheck';
import { LISTING_DATA_SOURCE_SMART_APARTMENT } from 'common/listingConstants';

export default function makeInviteRoommateLink({ user, listing, appUrl, householdId }) {
  typeCheck('appUrl::NonEmptyString', appUrl);
  return (
    `${appUrl}/invite-roommate` +
    `?phone=${encodeURIComponent(user.phone)}` +
    `&name=${encodeURIComponent(firstWordCapitalized(user.name))}` +
    `&listingId=${encodeURIComponent(listing.id)}` +
    `&householdId=${encodeURIComponent(householdId)}` +
    `&userId=${encodeURIComponent(user.id)}` +
    (listing.dataSource === LISTING_DATA_SOURCE_SMART_APARTMENT
      ? `&apartmentName=${encodeURIComponent(listing.apartmentName)}`
      : `&street=${encodeURIComponent(listing.addressStreetDisplay)}`)
  );
}
